import { render, staticRenderFns } from "./FileSelectionCard.vue?vue&type=template&id=0838bab8&scoped=true&"
import script from "./FileSelectionCard.vue?vue&type=script&lang=js&"
export * from "./FileSelectionCard.vue?vue&type=script&lang=js&"
import style0 from "./FileSelectionCard.vue?vue&type=style&index=0&id=0838bab8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0838bab8",
  null
  
)

export default component.exports